module.exports = {
	layouts: {
		events: Vue.component('events', require('./components/layouts/Events.vue').default),
		places: Vue.component('places', require('./components/layouts/Places.vue').default),
		allPlaces: Vue.component('all-places', require('./components/layouts/AllPlaces.vue').default)
	},

	global: {
		mobileFilter: Vue.component('mobile-filter', require('./components/global/MobileFilter.vue').default),
		pagination: Vue.component('pagination', require('./components/global/Pagination.vue').default),
		triggerPopup: Vue.component('trigger-popup', require('./components/global/TriggerPopup.vue').default)
	}
};
